// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__wHQmM","loaderOuter":"PageOverlayLoader_loaderOuter__1AROt"};